<template src="./Details.html">
</template>

<script>
export default {
    props: {
        itemId: {
            type: Number,
            required: true,
        },
    },
    created() {
        this.$store.dispatch("stockTransfers/getDetails", this.itemId);
    },
    computed: {
        stockTransfer() {
            return this.$store.state.stockTransfers.stockTransfer;
        }
    },
    data() {
        return {
            headers: [
                { text: 'اسم الدواء', value: 'medicineName' },
                { text: ' رقم التشغيلة', value: 'batchNo' },
                { text: 'تاريخ  انتهاء الصلاحية ', value: 'expirationDate' },
                { text: 'الكمية', value: 'quantity' },
            ],
        };
    },
};
</script>